// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".9c92fc08dd06b1dd898cc000fcc8cda8.js";
};